// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React, { useEffect, useState } from 'react';
import { fetchApi, fetchAssets } from "../../../actions/api";
import compose from "recompose/compose";
import {
  Grid,
  Typography,
  withStyles,
} from "@material-ui/core";
import styles from "./styles";
import { connect } from "react-redux";
import { getApiDetails, getAssets } from "../../../reducers/api";
import { StatusIndicator } from "../../../components";
import { getI18nFormattedMessage } from "../../../utils/intl";
import ApiAssets from "../../../pages/Api/Details/Assets";
import { string, object, arrayOf, func } from "prop-types";

export const ProductApiOverview = (props) => {

  const { selectedEntityUuid, apiDetails, classes, assets } = props;
  const [apiUuid, setApiUuid] = useState();
  const { name, portalStatus, description, ssgUrl } = apiDetails;
  const pageId = "product-doc-api-overview";

  useEffect(() => {
    if(selectedEntityUuid && selectedEntityUuid !== apiUuid) {
      setApiUuid(selectedEntityUuid);
    }
  }, [selectedEntityUuid])

  useEffect(() => {
    if (apiUuid) {
      props.fetchApi(apiUuid);
      props.fetchAssets(apiUuid);
    }
  }, [apiUuid]);

  return apiDetails ? (
    <Grid container className={classes.gridContainer}>
      <Grid item xs={12} md={12} className={classes.titleContainer}>
        <Typography
          id={`${pageId}-api-name}`}
          data-apim-test={`${pageId}-api-name}`}
          variant="h2"
        >
          {name}
        </Typography>
        <div>
          <StatusIndicator status={portalStatus}/>
          <Typography
            id={`${pageId}-api-url}`}
            data-apim-test={`${pageId}-api-url}`}
            className={classes.ssgUrlContainer}>
            {ssgUrl}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={6} md={6} className={classes.descriptionContainer}>
          <>
            <Typography
              id={`${pageId}-public-description-title}`}
              data-apim-test={`${pageId}-public-description-title}`}
              variant="h4"
            >
              {getI18nFormattedMessage('label.public.description')}
            </Typography>
            <Typography
              id={`${pageId}-public-description-body}`}
              data-apim-test={`${pageId}-public-description-body}`}
              variant="body1"
            >
              {description}
            </Typography>
          </>
      </Grid>
      <Grid item xs={6} md={6} className={classes.assetContainer}>
        { <ApiAssets api={apiDetails} apiAssets={assets}/> }
      </Grid>
    </Grid>
  ) : null
}

ProductApiOverview.propTypes = {
  selectedEntityUuid : string,
  apiDetails : object,
  classes : object,
  assets : arrayOf(object),
  fetchApi : func,
  fetchAssets : func,
}

const mapStateToProps = state => ({
  apiDetails: getApiDetails(state),
  assets: getAssets(state),
});

const mapDispatchToProps = {
  fetchApi,
  fetchAssets,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ProductApiOverview);

